/* eslint-disable react/no-danger */
// Code originally taken from client/src/components/faculty_notes.jsx and refactored.
import { InstructorNotesType } from "shared/types";
import { safeMarkdownToHtml } from "utils/markdown";

import "./instructor_notes.scss";

function InstructorNotes({ notes }: { notes: InstructorNotesType | undefined }) {
  if (!notes) {
    return null;
  }
  const {
    faculty_instructions: facultyInstructions,
    engagement_prompt: engagementPrompt,
    focus_questions: focusQuestions,
  } = notes;

  return (
    <div className="instructor-notes p1" data-testid="instructor-notes">
      {facultyInstructions && facultyInstructions.length > 0 && (
        <div className="mt3 px2">
          <h2 className="body-xs bold text-black-tint-70 mb2 pb1">FACULTY INSTRUCTIONS</h2>
          <div
            className="markdown-wrapper body-s text-white"
            dangerouslySetInnerHTML={safeMarkdownToHtml(facultyInstructions)}
          />
        </div>
      )}
      {engagementPrompt && engagementPrompt.length > 0 && (
        <div className="mt3 px2">
          <h2 className="body-xs bold text-black-tint-70 mb2 pb1">ENGAGEMENT PROMPT</h2>
          <div
            className="markdown-wrapper body-s text-white"
            dangerouslySetInnerHTML={safeMarkdownToHtml(engagementPrompt)}
          />
        </div>
      )}
      {focusQuestions && focusQuestions.length > 0 && (
        <div className="mt3 px2">
          <h2 className="body-xs bold text-black-tint-70 mb2 pb1">FOCUS QUESTIONS</h2>
          {focusQuestions.map(({ question, answer }, index) => (
            <div className="markdown-wrapper body-s text-white" key={question}>
              <p>Question {index + 1}.</p>
              <div dangerouslySetInnerHTML={safeMarkdownToHtml(question)} />
              <p>Answer {index + 1}.</p>
              <div dangerouslySetInnerHTML={safeMarkdownToHtml(answer)} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export { InstructorNotes };
